export default {
    mounted() {
        const leftArrowCode     = 37
        const rightArrowCode    = 39
        const arrowsKeyupCallback = e => {
            if( e.which === rightArrowCode )
                this.$ebus.requestGoToNextQuestion()
            if( e.which === leftArrowCode )
                this.$ebus.requestGoToPreviousQuestion()
        }

        $(document).keyup( arrowsKeyupCallback )

        this.trackCallback( () => $(document).unbind('keyup', arrowsKeyupCallback ) )
    }
}